// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

/** initla state for auth store  */
const initialState = {
  data: [],
  sales: [],
  count: "",
  current: {},
  perPageValues: [100, 200, 300, 400],
  itemPerPage: 100,
  currentPage: 1,
  filters: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  filtersSales: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  message: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const bidding = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCount: (s, payload) => {
      return {
        ...s,
        count: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setSales: (s, payload) => {
      return {
        ...s,
        sales: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    replaceRecord: (s, payload) => {
      const _data = s.data
      const index = s.data.findIndex((e) => e.pk === payload.pk)
      const item = s.data.find((e) => e.pk === payload.pk)
      item.status = payload.status
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.bidding],
        (bidding, biddingsLoading) => {
          return biddingsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.bidding],
        (bidding, biddingLoading) => biddingLoading.success
      )
    },
    /**
     *
     * @returns
     */
    paginationData() {
      return createSelector([slice], (bidding) => {
        let _data = bidding.data
        if (!isEmpty(bidding.filters)) {
          const status = bidding.filters.status
          _data = !!status
            ? status.value !== "ALL"
              ? _data.filter((e) => e.status.value === status)
              : _data
            : _data
          const offset = (bidding.currentPage - 1) * bidding.itemPerPage

          _data = drop(_data, offset).slice(0, bidding.itemPerPage)
        }
        if (!!bidding.keyword) {
          const options = {
            keys: ["phone", "stats"]
          }
          const fuse = new Fuse(bidding.data, options)
          _data = fuse.search(bidding.keyword)
          _data = _data.map((e) => e.item)
          const offset = (bidding.currentPage - 1) * bidding.itemPerPage
          _data = drop(_data, offset).slice(0, bidding.itemPerPage)
        }

        return _data
      })
    },
    /**
     *
     * @returns
     */
    paginationSales() {
      return createSelector([slice], (bidding) => {
        let _data = bidding.sales
        if (!isEmpty(bidding.filtersSales)) {
          const status = bidding.filtersSales.status
          _data = !!status
            ? status.value !== "ALL"
              ? _data.filter((e) => e.status.value === status)
              : _data
            : _data
          const offset = (bidding.currentPage - 1) * bidding.itemPerPage

          _data = drop(_data, offset).slice(0, bidding.itemPerPage)
        }
        if (!!bidding.keyword) {
          const options = {
            keys: ["phone", "stats"]
          }
          const fuse = new Fuse(bidding.sales, options)
          _data = fuse.search(bidding.keyword)
          _data = _data.map((e) => e.item)
          const offset = (bidding.currentPage - 1) * bidding.itemPerPage
          _data = drop(_data, offset).slice(0, bidding.itemPerPage)
        }

        return _data
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchSummaryBids() {
      appLogger.info("fetchSummaryBids", `[REDUX][${STORES.BIDDING}]`)
      this.setAction(globalConst.action.FETCH_SUMMARY_BIDS)
      try {
        const { items, count } = await API.get(
          "biddingApiGateway",
          "/bids/summary"
        )

        this.setData(items)
        this.setCount(count)
        // this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} param0
     */
    async deleteItem({ id, createdAt }) {
      appLogger.info("deleteItem", `[REDUX][${STORES.BIDDING}]`)
      this.setAction(globalConst.action.DELETE_ITEM)

      try {
        await API.post("auctionsApiGateway", `/auctions/${id}/rm`, {
          body: { sk: createdAt }
        })
        this.setMessage("msg_item_deleted")
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} param0
     */
    async setWinner({ id, customer }) {
      appLogger.info("setWinner", `[REDUX][${STORES.BIDDING}]`)
      this.setAction(globalConst.action.SET_WINNER)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setMessage("label_winner_updated")
        this.setAction(globalConst.action.NONE)
        return
      }

      try {
        await API.post(
          "adminsApi",
          `/auctions/v1/items/${id}/winner`,
          {
            body: { winnerPk: customer }
          }
        )
        this.setMessage("label_winner_updated")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        throw error
      }
    },
    /**
     *
     */
    async fetchBids() {
      appLogger.info("fetchBids", `[REDUX][${STORES.BIDDING}]`)
      this.setAction(globalConst.action.FETCH_BIDS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          `/bids/v1/items/active`
        )
  

        this.setData(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     */
    async fetchSales() {
      appLogger.info("fetchSales", `[REDUX][${STORES.BIDDING}]`)
      this.setAction(globalConst.action.FETCH_SALES)
      try {
        const { items, count } = await API.get("biddingApiGateway", "/sales")

        // this.setData(items)
        // this.setCount(count)
        // this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      this.setCurrentPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    }
  })
}
